import { useWorkspace } from '@/composables/useWorkspace';
import { getFlowsApiRequest } from '@/services/api/flows-api';
import { useStore } from '@/store';

export const populateFlowsStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = await getFlowsApiRequest({
    status: 'active',
    limit: '200',
    orderBy: 'updated',
    orderDirection: 'desc',
    columns: ['name', 'nameFull', 'id', 'countryId', 'workspaceId'],
  });
  store.cache.populateFlowsCache(payload);
  return payload;
};

export const updateFlowsStoreCacheApiRequest = async ({
  workspaceId,
  countryId,
}: {
  workspaceId: string;
  countryId: number;
}) => {
  const store = useStore();
  const workspaceApi = useWorkspace();
  const payload = await getFlowsApiRequest({
    status: 'active',
    limit: '200',
    columns: ['name', 'nameFull', 'id', 'countryId', 'workspaceId'],
    orderBy: 'updated',
    orderDirection: 'desc',
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
    ...(countryId !== 0 && { countryId }),
  });
  store.cache.updateFlowsCache({
    workspaceId,
    countryId,
    data: payload,
  });
  return payload;
};
